import React, { lazy, useCallback, useContext, useEffect, useState } from "react";
import { WORK_TICKET_HISTORY_COL } from "../../constants/WorkTicketHistoryConstants";
import { GridComponent } from "../../components/core/Table/GridComponent";
import { Spacer, SLNotification } from "../../components/core/utility";
import { Loader } from "@vds/loaders";
import { Breadcrumbs, BreadcrumbItem } from "@vds/breadcrumbs";

import { Body } from "@vds/typography/dist/cjs/components/Body";
import { generate } from "shortid";
import { updateNewrelicStats } from "../../../utility/newrelic";
import { C4SContext } from "../../context/c4sContext";
import { getInstallType, handleAddPage } from "./utils";
import { groupBy, orderBy } from "lodash";
import InProgressImg from "../../assets/icons/InProgress.svg";
import ErrorImg from "../../assets/icons/Error.svg";
import ReleasedImg from "../../assets/icons/Released.svg";
import ShippedImg from "../../assets/icons/Shipped.png";
import CancelImg from "../../assets/icons/Cancelled.svg";
import BackorderedImg from "../../assets/icons/Backordered.svg";
import ReturnSubmittedImg from "../../assets/icons/ReturnSubmitted.svg";
import SubmittedImg from "../../assets/icons/Submitted.svg";
import CreatedImg from "../../assets/icons/Created.svg";
import PackagingImg from "../../assets/icons/Packaging.svg";
import DeliveredImg from "../../assets/icons/Delivered.svg";
import { workTicketList } from "../../services/C4S Decommission - Replacement/workTicketList";
import moment from "moment";
import ThreeDotsTemplateWTA from "./ThreeDotsTemplateWTA";
import { deleteWorkTicket } from "../../services/C4S Decommission - Replacement/deleteWorkTicket";
import { OrderShippingSummaryAccordion } from "./OrderShippingSummaryAccordion";
import searchIcon from "../../assets/icons/search_blk.png";
import styled from "styled-components";
import { hasPrivilege } from "../../../utility/privileges";
import { Privileges } from "../../../constants/PrivilegeConstants";
import useOutsideClick from "../../customHook/use-outside-click";

import { WorkTicketHistoryDetailedViewWTAMetadata } from "./WorkTicketHistoryDetailedViewWTA";
import { SplitByMaterialViewMetadata } from "./SplitByMaterialView";

const SearchInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  border-bottom: 1px solid black;
  width: 170px;
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(10, max-content);
  gap: 1rem;
  margin-bottom: 1rem;
  margin-left: 0.5rem;

  @media screen and (min-width: 826px) and (max-width: 920px) {
    grid-template-columns: repeat(5, max-content);
  }
  @media (max-width: 826px) {
    grid-template-columns: repeat(4, max-content);
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SearchInput = styled.input`
  outline: none;
  border: none;
  height: 25px;
  width: 75%;
`;

const StyledNotification = styled(SLNotification)`
  & div {
    background: #0077b4 !important;
  }
`;

const WORK_TICKET_STATUS_LIST = [
  {
    label: "Submitted",
    scrImg: SubmittedImg,
    isCSP: true,
  },
  {
    label: "Created",
    scrImg: CreatedImg,
    isCSP: true,
  },
  {
    label: "Released",
    scrImg: ReleasedImg,
    isCSP: true,
  },
  {
    label: "Backordered",
    scrImg: BackorderedImg,
    isCSP: true,
  },
  {
    label: "Packaging",
    scrImg: PackagingImg,
    isCSP: true,
  },
  {
    label: "Shipped",
    scrImg: ShippedImg,
    isCSP: true,
  },
  {
    label: "Delivered",
    scrImg: DeliveredImg,
    isCSP: true,
  },
  {
    label: "Return Submitted",
    scrImg: ReturnSubmittedImg,
    isCSP: false,
  },
  {
    label: "Error",
    scrImg: ErrorImg,
    isCSP: true,
  },
  {
    label: "Cancelled",
    scrImg: CancelImg,
    isCSP: true,
  },
];

export default function WorkticketHistory(props) {
  const { cspDetails, notification, isSourceCSP } = useContext(C4SContext);
  const [isLoading, setIsLoading] = useState(false);
  const [workTicketListTable, setWorkTicketListTable] = useState([]);
  const [workTicketListColumns, setWorkTicketListColumns] = useState(
    isSourceCSP.isSourceCSP ? WORK_TICKET_HISTORY_COL.toSpliced(1, 1) : WORK_TICKET_HISTORY_COL.toSpliced(2, 1)
  );
  let caseData = null;
  sessionStorage && sessionStorage.getItem("CSPDetails") ? JSON.parse(sessionStorage.getItem("CSPDetails")) : null;
  caseData =
    sessionStorage && sessionStorage.getItem("CSPDetails")
      ? JSON.parse(sessionStorage.getItem("CSPDetails")).CASEDetails?.filter((caseDetail) => caseDetail.DefaultCase === "1")[0] ?? ""
      : null;
  const [globalSearchValue, setGlobalSearchValue] = useState("");
  const handleClickOutside = () => {
    notification.setNotification(null);
  };

  const clickRef = useOutsideClick(handleClickOutside);
  useEffect(() => {
    setTimeout(() => {
      getWorkTicketUpdateError();
    }, 500);
    getWorkTicketList();
  }, []);
  const getWorkTicketUpdateError = () => {
    let workticketUpdateError = sessionStorage.getItem("workticketUpdateError");
    if (workticketUpdateError) {
      notification.setNotification(
        <SLNotification
          key={generate()}
          type={"error"}
          title={`WorkTicket created but failed to update status on ${workticketUpdateError}`}
          fullBleed={true}
          ref={clickRef}
        />
      );
      sessionStorage.setItem("workticketUpdateError", "");
    }
  };
  let limitWT = sessionStorage.getItem("limitWTCreation") == "true" ? true : false;

  const getWorkTicketList = async () => {
    let cspAccountDetails = null;
    cspAccountDetails = sessionStorage && sessionStorage.getItem("CSPDetails") ? JSON.parse(sessionStorage.getItem("CSPDetails")) : null;
    if (cspAccountDetails === null) return false;
    updateNewrelicStats();
    setIsLoading(true);
    let payLoad = {
      accountId: props?.AccountID,
      cspId:
        isSourceCSP.isSourceCSP && cspAccountDetails?.CSP?.length
          ? cspAccountDetails.CSP.filter((csp) => csp.DefaultCSP === "1")[0].CSPID || null
          : null,
      caseId:
        !isSourceCSP.isSourceCSP && cspAccountDetails?.CASEDetails?.length
          ? cspAccountDetails.CASEDetails.filter((cases) => cases.DefaultCase === "1")[0].CaseSFDCID || null
          : null,
    };
    let response = await workTicketList(payLoad);
    if (response.status === 200) {
      let responseWithCityState = response.data.data.map((data) => {
        data.installType = getInstallType(data.installType);
        data.cityState = `${data.city}, ${data.stateCode}`;
        return data;
      });
      let sortedResponse = orderBy(
        responseWithCityState,
        [
          function (o) {
            return new Date(o.modifiedAt);
          },
          function (o) {
            return new Date(o.createdAt);
          },
          "installType",
          "cityState",
        ],
        ["desc", "desc"]
      );
      if (!isSourceCSP.isSourceCSP) {
        let currentCase = groupBy(responseWithCityState, { caseNumber: caseData.CaseNumber }).true ?? [];
        let otherCase = groupBy(responseWithCityState, { caseNumber: caseData.CaseNumber }).false ?? [];
        currentCase = orderBy(
          currentCase,
          function (o) {
            return new Date(o.modifiedAt);
          },
          "desc"
        );
        otherCase = orderBy(
          otherCase,
          function (o) {
            return new Date(o.modifiedAt);
          },
          "desc"
        );
        sortedResponse = [...currentCase, ...otherCase];
      }
      sortedResponse = sortedResponse.map((data) => {
        return {
          caseNumber: data.caseNumber,
          ticketId: data.workticketId,
          workticketType: data.workticketType,
          migratedRecord: data.workticketId?.length && data.workticketId[0] === "W" ? false : true,
          workOrderOwner: data.workOrderOwner,
          installType: data.installType,
          hasEsnToBeReturned: data.hasEsnToBeReturned,
          cityState: `${data.city}, ${data.stateCode}`,
          addressToShow: `${data.addressOne} ${data.addressTwo},${data.stateCode}, ${data.zipCode}`,
          status: data.wtStatus,
          allowCancel: data.allowCancel,
          cancellationReason: data.cancellationReason,
          requestDate: data.requestDate,
          erpTicketType: data.erpTicketType,
          addressOne: data.addressOne,
          addressTwo: data.addressTwo,
          city: data.city,
          stateCode: data.stateCode,
          country: data.country,
          zipCode: data.zipCode,
          workTicket: data.workticketId,
          contactName: data.contactName || "",
          phone: data.phoneNumber || "",
          email: data.emailAddress || "",
          division: data?.division || null,
          distributionChannel: data?.distChannel || null,
          salesOrg: data.salesOrg,
          salesOrderId: data.salesOrderId,
          totalEsnCount: data.totalEsnCount,
          sourceWorkticket: data.sourceWorkticket,
          contractAccount: data.contractAccount,
          assignedTo: data.assignTo,
          crmReferenceId: isSourceCSP.isSourceCSP
            ? cspAccountDetails?.CSP?.length
              ? cspAccountDetails.CSP[0].CRM_Ref_ID
              : null
            : cspAccountDetails?.CASEDetails?.length
            ? cspAccountDetails.CASEDetails[0].CaseNumber
            : null,
          currencyCode: data.currencyCode,
          erpPartnerNumber: cspAccountDetails?.ERP_Partner_Number ?? null,
          erpPrimaryContactNumber: cspAccountDetails?.ERP_Primary_Contact_NUmber ?? null,
          accountName: cspAccountDetails?.AccountName ?? null,
          cspCustomerPONumber: cspAccountDetails?.CSP_CUstomer_PO_Number ?? null,
          subStatus: data.subStatus,
          erpStatus: data.erpStatus,
          wareHouseNotes: data.wareHouseNotes,
          returnReason: data.returnReason || "",
          returnSubReason: data.returnSubReason || "",
          esnNotes: data.esnNotes,
          erpMigrationData: {
            x1ErpSalesRepId: data.x1ErpSalesRepId,
            xcontactMobile: data.xcontactMobile,
            xc4sObjectId: data.xc4sObjectId,
            xschedulingNotes: data.xschedulingNotes,
            xvendorMessage: data.xvendorMessage,
            xnotesToTechnician: data.xnotesToTechnician,
            xfieldNotes: data.xfieldNotes,
            xrequestStartDateTime: data.xrequestStartDateTime,
            xrequestEndDateTime: data.xrequestEndDateTime,
            xvendorId: data.xvendorId,
          },
          ownerName: data.assignedTo,
          assignedToEid: data.assignedToEid,
          assignedToEmail: data.assignedToEmail,
          createdBy: data.createdBy,
          createdByEid: data.createdByEid,
          createdByEmail: data.createdByEmail,
          createdOn: data.createdAt,
          modifiedAt: data?.modifiedAt ? moment(data.modifiedAt).format("MM/DD/YYYY") : null,
          modifiedBy: data.modifiedBy,
          modifiedByEid: data.modifiedByEid,
          modifiedByEmail: data.modifiedByEmail,
          addressId: data.addressId,
          contactId: data.contactId,
          returnLabelName: data.returnLabelName || "",
          returnLabelPhone: data.returnLabelPhone || "",
          returnLabelEmail: data.returnLabelEmail || "",
        };
      });
      setWorkTicketListTable(sortedResponse);
    } else {
      notify("We are currently experiencing issues, please try again", "error");
    }
    setIsLoading(false);
  };

  const navigate = (data, key) => {
    notification.setNotification(null);
    let filteredWorkTicketList;
    if (key === "Ticket ID") {
      WorkTicketHistoryDetailedViewWTAMetadata.name = data.ticketId;
    } else {
      WorkTicketHistoryDetailedViewWTAMetadata.name = data.sourceWorkticket;
      filteredWorkTicketList = workTicketListTable.filter((item) => {
        return item.ticketId === data.sourceWorkticket;
      });
      data = filteredWorkTicketList[0];
    }
    handleAddPage(WorkTicketHistoryDetailedViewWTAMetadata.id, {
      data: data,
      AccountID: props?.AccountID,
      ID: props?.ID,
      userId: props?.userId,
      renderSplitByMaterial: showSplitByMaterialView, // Pass the function here
    });
  };

  const showSplitByMaterialView = (data) => {
    notification.setNotification(null);
    SplitByMaterialViewMetadata.name = data.ticketId;
    handleAddPage(SplitByMaterialViewMetadata.id, { data: data, AccountID: props?.AccountID, ID: props?.ID, userId: props?.userId });
  };

  const notify = (content, type) => {
    notification.setNotification(<SLNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} />);
  };

  const callDeleteTicket = useCallback(async (ticketID) => {
    setIsLoading(true);
    const payload = { firstName: cspDetails.cspDetails.firstName, lastName: cspDetails.cspDetails.lastName, ticketID: ticketID };
    let response = await deleteWorkTicket(payload);
    if (response.status === 200 && response?.data?.statusCode === "200") {
      notify("Ticket has been deleted successfully!", "success");
      getWorkTicketList();
    } else {
      notify("We are currently experiencing issues, please try again", "error");
    }
    setIsLoading(false);
  }, []);

  const threeDotsTemplate = (rowData) => {
    return (
      <ThreeDotsTemplateWTA
        ticketDetails={rowData}
        callDeleteTicket={callDeleteTicket}
        notify={notify}
        getWorkTicketList={getWorkTicketList}
        id={props?.ID}
        userId={props?.userId}
        renderSplitByMaterial={showSplitByMaterialView}
      />
    );
  };

  const onGlobalSearchChange = (e) => {
    setGlobalSearchValue(e.target.value);
  };

  const supportCaseBanner = !isSourceCSP.isSourceCSP && (
    <StyledNotification
      key={generate()}
      type="info"
      title={
        <>
          Your Case:<> {caseData?.CaseNumber}</>
        </>
      }
    />
  );
  const caseIdentifier = (caseNumber) => (caseData ? caseNumber === caseData.CaseNumber : false);

  return (
    <>
      <Loader active={isLoading} fullscreen />
      <Spacer top="10px" />
      <Breadcrumbs surface="light">
        <BreadcrumbItem key={0} active={false}>
          <span
            css={{
              fontWeight: "700",
              color: "black",
            }}
            onClick={() => {}}
          >
            {"Work Ticket History"}
          </span>
        </BreadcrumbItem>
      </Breadcrumbs>
      <Spacer bottom="1rem" />
      <OrderShippingSummaryAccordion></OrderShippingSummaryAccordion>
      <h2>Work Ticket History</h2>
      {workTicketListTable && workTicketListTable.length > 0 && (
        <div style={{ display: "flex", marginBottom: "-30px" }}>
          <legend style={{ "font-size": ".9rem", "font-weight": "600", "line-height": "1.25rem", "font-family": "Verizon-NHG-eDS" }}>STATUS </legend>
          <Wrapper>
            {isSourceCSP.isSourceCSP
              ? WORK_TICKET_STATUS_LIST.filter((item) => item.isCSP).map((item) => {
                  return (
                    <StatusWrapper key={item.label + "_status"}>
                      {item.label === "Shipped" ? (
                        <img src={item.scrImg} alt="Status-Icon" css={{ marginRight: "4px" }} height="20px" width="20px" />
                      ) : (
                        <img src={item.scrImg} alt="Status-Icon" css={{ marginRight: "4px" }} height="20px" width="20px" />
                      )}
                      <Body primitive="span">{`- ${item.label}`}</Body>
                    </StatusWrapper>
                  );
                })
              : WORK_TICKET_STATUS_LIST.map((item) => {
                  return (
                    <StatusWrapper key={item.label + "_status"}>
                      {item.label === "Shipped" ? (
                        <img src={item.scrImg} alt="Status-Icon" css={{ marginRight: "4px" }} height="20px" width="20px" />
                      ) : (
                        <img src={item.scrImg} alt="Status-Icon" css={{ marginRight: "4px" }} height="20px" width="20px" />
                      )}
                      <Body primitive="span">{`- ${item.label}`}</Body>
                    </StatusWrapper>
                  );
                })}
          </Wrapper>
        </div>
      )}
      <div css={{ display: "flex", justifyContent: "flex-end" }}>
        <SearchInputWrapper>
          <SearchInput
            role="search"
            aria-label={globalSearchValue}
            value={globalSearchValue}
            type="text"
            onChange={onGlobalSearchChange}
            placeholder="Search"
          ></SearchInput>
          <img aria-label="search" role="img" src={searchIcon} height="20px" width="20px"></img>
        </SearchInputWrapper>
      </div>
      <GridComponent
        isSelectionEnabled={false}
        isExportEnabled={false}
        noDataMessage="No data available to display"
        rows={workTicketListTable}
        columns={workTicketListColumns}
        hideGlobalFilter={true}
        renderDataWithImage={renderImage}
        caseIdentifier={caseIdentifier}
        paginator={true}
        threeDotsTemplate={!limitWT && !hasPrivilege(Privileges.ENABLE_WORKTICKET_PORTAL_READONLY) && threeDotsTemplate}
        hyperLinkClicked={navigate}
        selectionAutoFocus={false}
        headerBanner={supportCaseBanner}
        searchKeyboardValue={globalSearchValue}
      />
    </>
  );
}

export const WorkticketHistoryMetadata = {
  name: "Workticket History",
  id: "workticket_history",
  component: lazy(() => import("./WorkticketHistory")),
  route: "/workticket_history",
  breadcrumbs: true,
};

export const renderImage = (data, rowData) => {
  let workTicketStatus = rowData?.status?.toLowerCase();
  let statusIcon;
  switch (workTicketStatus) {
    case "error":
      statusIcon = ErrorImg;
      break;
    case "released":
      statusIcon = ReleasedImg;
      break;
    case "shipped":
      statusIcon = ShippedImg;
      break;
    case "cancelled":
      statusIcon = CancelImg;
      break;
    case "return submitted":
      statusIcon = ReturnSubmittedImg;
      break;
    case "backordered":
      statusIcon = BackorderedImg;
      break;
    case "submitted":
      statusIcon = SubmittedImg;
      break;
    case "created":
      statusIcon = CreatedImg;
      break;
    case "packaging":
      statusIcon = PackagingImg;
      break;
    case "delivered":
      statusIcon = DeliveredImg;
      break;
    default:
      statusIcon = InProgressImg;
  }
  return rowData.salesOrg === data ? (
    renderToolTip(data)
  ) : (
    <div data-testid="status-row" css={{ display: "flex" }}>
      <img src={statusIcon} alt="Status-Icon" height="20px" width="20px" css={{ marginRight: "3px" }} />
      <Body primitive="span">{rowData?.status}</Body>
    </div>
  );
};

export const renderToolTip = (data) => {
  return <span data-testid="tooltip">{data?.slice(0, 4)}</span>;
};
